export default {
  // Default variant
  //-------------------------------------------------------------------------
  default: {
    root: "relative w-full items-center",
    label: "block text-sm font-medium text-text_secondary mb-1",
    required: "text-error",
    input_wrapper: "relative flex items-center",
    icon_wrapper: "absolute left-3 flex items-center pointer-events-none",
    input:
      "rounded-full w-full text-text bg-canvas focus:bg-canvas border border-bordered focus:outline-none focus:ring-1 focus:ring-primary focus:border-transparent px-3 py-2",
    input_with_icon: "pl-10",
    textarea:
      "w-full px-3 py-2 bg-canvas focus:bg-canvas border border-bordered rounded-md focus:outline-none focus:ring-1 focus:ring-primary focus:border-transparent",
    error_text: "mt-1 text-sm text-error",
    error_state: "border-error",
  },

  // Admin variant (rectangular with smaller rounding for Admin panels)
  //-------------------------------------------------------------------------
  admin: {
    root: "relative w-full items-center",
    label: "block text-sm font-medium text-admin_text_secondary mb-1",
    required: "text-admin_error",
    input_wrapper: "relative flex items-center",
    icon_wrapper: "absolute left-3 flex items-center pointer-events-none",
    input:
      "h-10 rounded-lg w-full text-admin_text bg-admin_canvas border border-admin_canvas focus:bg-admin_canvas focus:outline-none focus:ring-1 focus:ring-admin_primary focus:border-transparent px-3",
    input_with_icon: "pl-10",
    textarea:
      "w-full px-3 py-2 text-admin_text bg-admin_canvas border border-admin_canvas focus:bg-admin_canvas rounded-lg focus:outline-none focus:ring-1 focus:ring-admin_primary focus:border-transparent",
    error_text: "mt-1 text-sm text-admin_error",
    error_state: "border-admin_error",
  },

  // Compact variant with smaller padding and text
  //-------------------------------------------------------------------------
  compact: {
    root: "relative w-full items-center",
    label: "block text-xs font-medium text-text_secondary mb-0.5",
    required: "text-error",
    input_wrapper: "relative flex items-center",
    icon_wrapper: "absolute left-2 flex items-center pointer-events-none",
    input:
      "rounded-full w-full px-2 py-1 text-sm bg-canvas focus:bg-canvas border border-bordered shadow-sm focus:outline-none focus:ring-1 focus:ring-primary focus:border-transparent",
    input_with_icon: "pl-8",
    textarea:
      "w-full px-2 py-1 text-sm bg-canvas focus:bg-canvas border border-bordered rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-primary focus:border-transparent",
    error_text: "mt-0.5 text-xs text-error",
    error_state: "border-error",
  },

  admin_compact: {
    root: "relative w-full items-center",
    label: "block text-xs font-medium text-admin_text_secondary mb-0.5",
    required: "text-admin_error",
    input_wrapper: "relative flex items-center",
    icon_wrapper: "absolute left-2 flex items-center pointer-events-none",
    input:
      "rounded-full w-full px-2 py-1 text-sm bg-admin_canvas focus:bg-admin_canvas border border-admin_bordered shadow-sm focus:outline-none focus:ring-1 focus:ring-admin_primary focus:border-transparent",
    input_with_icon: "pl-8",
    textarea:
      "w-full px-2 py-1 text-sm bg-admin_canvas focus:bg-admin_canvas border border-admin_bordered rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-admin_primary focus:border-transparent",
    error_text: "mt-0.5 text-xs text-admin_error",
    error_state: "border-admin_error",
  },

  // Large variant with increased padding and text size
  //-------------------------------------------------------------------------
  large: {
    root: "relative w-full items-center",
    label: "block text-base font-medium text-text_secondary mb-2",
    required: "text-error",
    input_wrapper: "relative flex items-center",
    icon_wrapper: "absolute left-4 flex items-center pointer-events-none",
    input:
      "rounded-full w-full px-4 py-3 text-lg bg-canvas focus:bg-canvas border border-bordered shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent",
    input_with_icon: "pl-12",
    textarea:
      "w-full px-4 py-3 text-lg bg-canvas focus:bg-canvas border border-bordered rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent",
    error_text: "mt-2 text-sm text-error",
    error_state: "border-error",
  },

  admin_large: {
    root: "relative w-full items-center",
    label: "block text-base font-medium text-admin_text_secondary mb-2",
    required: "text-admin_error",
    input_wrapper: "relative flex items-center",
    icon_wrapper: "absolute left-4 flex items-center pointer-events-none",
    input:
      "rounded-full w-full px-4 py-3 text-lg bg-admin_canvas focus:bg-admin_canvas border border-admin_bordered shadow-sm focus:outline-none focus:ring-2 focus:ring-admin_primary focus:border-transparent",
    input_with_icon: "pl-12",
    textarea:
      "w-full px-4 py-3 text-lg bg-admin_canvas focus:bg-admin_canvas border border-admin_bordered rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-admin_primary focus:border-transparent",
    error_text: "mt-2 text-sm text-admin_error",
    error_state: "border-admin_error",
  },

  // Floating label variant
  //-------------------------------------------------------------------------
  floating: {
    root: "relative w-full items-center pt-5",
    label:
      "absolute left-3 -top-2 px-1 text-sm font-medium text-text_secondary bg-canvas transition-all",
    required: "text-error",
    input_wrapper: "relative flex items-center",
    icon_wrapper: "absolute left-3 flex items-center pointer-events-none",
    input:
      "rounded-full w-full px-3 py-2 bg-canvas focus:bg-canvas border border-bordered shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent",
    input_with_icon: "pl-10",
    textarea:
      "w-full px-3 py-2 bg-canvas focus:bg-canvas border border-bordered rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent",
    error_text: "mt-1 text-sm text-error",
    error_state: "border-error",
  },

  admin_floating: {
    root: "relative w-full items-center pt-5",
    label:
      "absolute left-3 -top-2 px-1 text-sm font-medium text-admin_text_secondary bg-admin_canvas transition-all",
    required: "text-admin_error",
    input_wrapper: "relative flex items-center",
    icon_wrapper: "absolute left-3 flex items-center pointer-events-none",
    input:
      "rounded-full w-full px-3 py-2 bg-admin_canvas focus:bg-admin_canvas border border-admin_bordered shadow-sm focus:outline-none focus:ring-2 focus:ring-admin_primary focus:border-transparent",
    input_with_icon: "pl-10",
    textarea:
      "w-full px-3 py-2 bg-admin_canvas focus:bg-admin_canvas border border-admin_bordered rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-admin_primary focus:border-transparent",
    error_text: "mt-1 text-sm text-admin_error",
    error_state: "border-admin_error",
  },

  // Borderless variant
  //-------------------------------------------------------------------------
  borderless: {
    root: "relative w-full items-center",
    label: "block text-sm font-medium text-text_secondary mb-1",
    required: "text-error",
    input_wrapper: "relative flex items-center",
    icon_wrapper: "absolute left-3 flex items-center pointer-events-none",
    input:
      "rounded-full w-full px-3 py-2 bg-canvas focus:bg-canvas shadow-sm focus:outline-none focus:ring-2 focus:ring-primary",
    input_with_icon: "pl-10",
    textarea:
      "w-full px-3 py-2 bg-canvas focus:bg-canvas rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-primary",
    error_text: "mt-1 text-sm text-error",
    error_state: "ring-2 ring-error",
  },

  admin_borderless: {
    root: "relative w-full items-center",
    label: "block text-sm font-medium text-admin_text_secondary mb-1",
    required: "text-admin_error",
    input_wrapper: "relative flex items-center",
    icon_wrapper: "absolute left-3 flex items-center pointer-events-none",
    input:
      "rounded-full w-full px-3 py-2 bg-admin_canvas focus:bg-admin_canvas shadow-sm focus:outline-none focus:ring-2 focus:ring-admin_primary",
    input_with_icon: "pl-10",
    textarea:
      "w-full px-3 py-2 bg-admin_canvas focus:bg-admin_canvas rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-admin_primary",
    error_text: "mt-1 text-sm text-admin_error",
    error_state: "ring-2 ring-admin_error",
  },

  // Help Center search variant
  //-------------------------------------------------------------------------
  hc_search: {
    root: "relative w-full items-center",
    label: "block text-sm font-medium text-text_secondary mb-1",
    required: "text-error",
    input_wrapper: "relative flex items-center",
    icon_wrapper: "absolute left-3 flex items-center pointer-events-none",
    input:
      "rounded-full w-full text-text bg-canvas focus:bg-canvas border border-bordered focus:outline-none focus:ring-1 focus:ring-primary focus:border-transparent pl-6 pr-3 py-2",
    input_with_icon: "pl-10",
    textarea:
      "w-full px-3 py-2 bg-canvas focus:bg-canvas border border-bordered rounded-md focus:outline-none focus:ring-1 focus:ring-primary focus:border-transparent",
    error_text: "mt-1 text-sm text-error",
    error_state: "border-error",
  },

  // Admin preview variant - for showing preview content with distinct styling
  //-------------------------------------------------------------------------
  admin_preview: {
    root: "relative w-full items-center",
    label: "block text-sm font-medium text-admin_text_secondary mb-1",
    required: "text-admin_error",
    input_wrapper: "relative flex items-center",
    icon_wrapper: "absolute left-3 flex items-center pointer-events-none",
    input:
      "rounded-full w-full text-admin_text bg-admin_neutral_1 focus:bg-admin_neutral_1 border border-admin_neutral_2 focus:outline-none focus:ring-1 focus:ring-admin_secondary focus:border-transparent px-3 py-2 italic opacity-90 cursor-default",
    input_with_icon: "pl-10",
    textarea:
      "w-full px-3 py-2 text-admin_text bg-admin_neutral_1 focus:bg-admin_neutral_1 border border-admin_neutral_2 rounded-md focus:outline-none focus:ring-1 focus:ring-admin_secondary focus:border-transparent italic opacity-90 cursor-default",
    error_text: "mt-1 text-sm text-admin_error",
    error_state: "border-admin_error",
  },

  // Store checkout flow defaults (ported from the aqua purchase flow)
  aqua_input: {
    root: "text-text",
    input_wrapper: "relative flex items-center",
    icon_wrapper: "absolute left-5 flex items-center pointer-events-none text-primary",
    input: "h-[40px] md:h-[44px] lg:h-[48px] rounded-full w-full px-4 py-2 text-[14px] md:text-[16px] lg:text-[18px] xl:text-[20px] text-gray_1 bg-theme_white focus:bg-theme_white border border-gray_2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-none",
    input_with_icon: "pl-14",
    textarea: "w-full px-3 py-2 focus:transparent border border-none rounded-md focus:outline-none focus:ring-1 focus:border-none",
  },

  aqua: {
    root: "relative w-full items-center",
    label: "block text-sm font-medium text-text mb-2",
    required: "text-error",
    input_wrapper: "relative flex items-center",
    icon_wrapper: "absolute left-3 flex items-center pointer-events-none",
    input: "rounded-[12px] w-full text-text bg-theme_white focus:bg-theme_white border border-gray_2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent px-4 py-3 text-[14px] md:text-[16px]",
    input_with_icon: "pl-10",
    textarea: "w-full px-4 py-3 bg-theme_white focus:bg-theme_white border border-gray_2 rounded-[12px] focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-[14px] md:text-[16px]",
    error_text: "mt-1 text-sm text-error",
    error_state: "border-error",
  },
}
